import { IdentificationCard } from "@phosphor-icons/react";
import { Reveal } from "./Reveal";
import { LOGO_URL } from "../lib/site";
import { CardStatus } from "./RenewalNotice";

export const MemberCard = ({ user, c }) => {
  const card = user.card;
  if (!card) return null;
  const rows = [
    [c.cardJoined, card.joined],
    [c.cardExpires, card.expires],
  ];
  return (
    <Reveal delay={0.08} data-testid="member-card">
      <div className="relative overflow-hidden rounded-[1.75rem] bg-ink text-bone p-7 md:p-9 shadow-2xl">
        <div className="pointer-events-none absolute -right-16 -top-16 h-56 w-56 rounded-full bg-terracotta/30 blur-3xl" />
        <div className="pointer-events-none absolute -left-10 -bottom-20 h-56 w-56 rounded-full bg-forest/40 blur-3xl" />
        <div className="relative flex items-start justify-between gap-6">
          <div>
            <p className="font-display font-bold tracking-widest text-[11px] text-ochre">{c.cardKicker}</p>
            <h3 className="mt-2 font-display font-extrabold tracking-tight text-2xl md:text-3xl" data-testid="member-card-name">{user.name}</h3>
            <div className="mt-1 flex flex-wrap items-center gap-2">
              <p className="text-sm text-bone/70" data-testid="member-card-type">{card.type}</p>
              <CardStatus expires={card.expires} c={c} />
            </div>
          </div>
          <div className="rounded-xl bg-bone p-2 shrink-0">
            <img src={LOGO_URL} alt="Common Ground Project" className="h-10 w-auto" />
          </div>
        </div>
        <div className="relative mt-8 grid gap-6 sm:grid-cols-3">
          <div className="sm:col-span-1">
            <p className="text-[11px] tracking-widest text-bone/50 font-display font-bold">{c.cardNumber}</p>
            <p className="mt-1 font-mono text-lg tracking-wider" data-testid="member-card-number">{card.number}</p>
          </div>
          {rows.map(([label, value]) => (
            <div key={label}>
              <p className="text-[11px] tracking-widest text-bone/50 font-display font-bold">{label}</p>
              <p className="mt-1 text-lg">{value || "—"}</p>
            </div>
          ))}
        </div>
        <div className="relative mt-8 flex items-center gap-2 text-xs text-bone/60">
          <IdentificationCard size={16} weight="duotone" className="text-ochre" />
          {c.cardFooter}
        </div>
      </div>
    </Reveal>
  );
};
